import script from "./Agent.vue?vue&type=script&setup=true&lang=js"
export * from "./Agent.vue?vue&type=script&setup=true&lang=js"

import "./Agent.vue?vue&type=style&index=0&id=0ef9f27a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef9f27a"]])

export default __exports__